module.exports = __webpack_public_path__ + "cb342b842335b154e23793310064664d.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update/2018-03-04/whats-new.html
// module id = 2206
// module chunks = 0